(function () {
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  document.querySelectorAll('[data-filter-group]').forEach(function (group) {
    var tabs = group.querySelectorAll('[data-filter]');
    var cards = group.querySelectorAll('[data-tags]');
    var empty = group.querySelector('[data-empty]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var f = tab.getAttribute('data-filter');
        var shown = 0;
        tabs.forEach(function (t) { t.setAttribute('aria-pressed', t === tab ? 'true' : 'false'); });
        cards.forEach(function (c) {
          var match = f === 'all' || (' ' + c.getAttribute('data-tags') + ' ').indexOf(' ' + f + ' ') > -1;
          c.hidden = !match;
          if (match) shown++;
        });
        if (empty) empty.hidden = shown > 0;
      });
    });
  });
  var gate = document.querySelector('[data-gate]');
  if (gate) {
    var ok = false;
    try { ok = localStorage.getItem('ruo_ack') === '1'; } catch (e) {}
    if (!ok) gate.hidden = false;
    var accept = gate.querySelector('[data-gate-accept]');
    if (accept) accept.addEventListener('click', function () {
      try { localStorage.setItem('ruo_ack', '1'); } catch (e) {}
      gate.hidden = true;
    });
  }
  var attest = document.querySelector('[data-attest]');
  var checkout = document.querySelector('[data-checkout]');
  if (attest && checkout) {
    var sync = function () { checkout.disabled = !attest.checked; };
    attest.addEventListener('change', sync);
    sync();
  }
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-step'), 10);
        input.value = Math.max(parseInt(input.min || '1', 10), v);
      });
    });
  });
  document.querySelectorAll('[data-variant-pills]').forEach(function (wrap) {
    var form = wrap.closest('form');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var addBtn = form && form.querySelector('.add-btn');
    wrap.addEventListener('change', function (e) {
      var r = e.target;
      if (!r.dataset) return;
      if (priceEl) priceEl.textContent = money(parseInt(r.dataset.price, 10));
      if (compareEl) {
        var c = parseInt(r.dataset.compare || '0', 10);
        compareEl.textContent = c > 0 ? money(c) : '';
      }
      if (addBtn) {
        var avail = r.dataset.available === 'true';
        addBtn.disabled = !avail;
        addBtn.textContent = avail ? 'Add to Cart' : 'Sold out';
      }
    });
  });
  document.querySelectorAll('[data-ptabs]').forEach(function (t) {
    var btns = t.querySelectorAll('[role="tab"]');
    var panels = t.querySelectorAll('[role="tabpanel"]');
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        btns.forEach(function (x, j) { x.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
      });
    });
  });
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-src]').forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.getAttribute('data-src');
        g.querySelectorAll('[data-src]').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    });
  });
})();
